import { Action, Module, VuexModule } from 'vuex-module-decorators';

import httpService from '@/services/http';

import { StoreSingleton } from '.';
import { sessionStore } from './session';

declare type PeopleResponse = {
  content: {
    peoplePerPage: {
      name: string;
      cpf?: string;
      email: string;
      events: { name: string; alias: string; username?: string }[];
    }[];
    totalEvents: { name: string; alias: string }[];
  };
  page: number;
  pageSize: number;
  totalPages: number;
};

@Module({
  name: 'peopleStore',
  namespaced: true,
  stateFactory: true,
  dynamic: true,
  preserveState: true,
  store: StoreSingleton.getInstance(),
})
class PeopleStore extends VuexModule {
  @Action
  async list(query?: any) {
    const response: PeopleResponse = (
      await httpService(sessionStore.session).get(`/people`, {
        params: {
          ...query,
        },
      })
    ).data;

    return response;
  }
}

export default PeopleStore;
